var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "copy-search" }, [
    _c(
      "div",
      { staticClass: "copy-search-body" },
      [
        _c("c-searchcode", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.is_disp_code,
              expression: "is_disp_code"
            }
          ],
          ref: "refcode",
          attrs: {
            r_title: _vm.r_messages.text_code,
            r_code_max: _vm.code_max,
            r_code_min: _vm.code_min
          }
        }),
        _vm._v(" "),
        _c("c-searchname", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.is_disp_name,
              expression: "is_disp_name"
            }
          ],
          ref: "refname",
          attrs: {
            r_title: _vm.r_messages.free_word,
            r_messages: _vm.r_messages,
            r_max_length: _vm.r_default_name,
            r_is_radio_hide: true
          }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.disp_btnSearch,
            expression: "disp_btnSearch"
          }
        ],
        staticClass: "conditions-list-btns"
      },
      [
        _c(
          "button",
          { staticClass: "search-btn", on: { click: _vm.onBtnSearch } },
          [_c("i", { staticClass: "fa-solid fa-magnifying-glass" })]
        )
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4a6eb82", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4a6eb82","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/parts_com/search/ifSearchSelection.vue
// module id = 554
// module chunks = 0 1 2